import React from 'react';

// This component matches the animated background and floating orbs from the landing page
const DocsAnimatedBackground: React.FC = () => (
  <>
    <div className="animated-bg"></div>
    <div className="floating-orbs">
      <div className="orb"></div>
      <div className="orb"></div>
      <div className="orb"></div>
    </div>
  </>
);

export default DocsAnimatedBackground;
